import { useMemo } from 'react'
import { collection } from 'firebase/firestore'
import { useCollection } from 'react-firebase-hooks/firestore'
import { firebase_firestore } from '../common/firebaseConfig'

type HiddenBacktestDoc = {
  backtestId?: string
  hidden?: boolean
  status?: string
}

/**
 * Subscribe to the user's hidden backtests and return a Set of hidden ids.
 */
export function useHiddenBacktests(gcid?: string | null): Set<string> {
  const hiddenCollectionRef = useMemo(() => {
    if (!gcid) return null
    return collection(firebase_firestore, `usermeta/${gcid}/hiddenBacktests`)
  }, [gcid])

  const [snapshot, loading, error] = useCollection(hiddenCollectionRef)

  return useMemo(() => {
    if (!hiddenCollectionRef || loading || error || !snapshot) {
      return new Set<string>()
    }

    const hiddenIds: string[] = []

    snapshot.forEach((doc) => {
      const data = doc.data() as HiddenBacktestDoc
      const backtestId =
        typeof data?.backtestId === 'string' && data.backtestId.trim()
          ? data.backtestId.trim()
          : doc.id

      // Only include the entry if it's still marked hidden
      if (backtestId && (data?.hidden ?? true) && data?.status !== 'unhidden') {
        hiddenIds.push(backtestId)
      }
    })

    return new Set(hiddenIds)
  }, [hiddenCollectionRef, snapshot, loading, error])
}

export default useHiddenBacktests
